import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Spring } from 'react-spring/renderprops';

import ItemFooterActions from 'components/ItemFooterActions';
import PanelContainer from 'components/PanelContainer';
import InboxItemTypeReceived from 'scenes/List/components/InboxItem/components/InboxItemTypeReceived';
import InboxItemTypeSent from 'scenes/List/components/InboxItem/components/InboxItemTypeSent';

import {
  MESSAGE_FROM_TYPE,
  MESSAGE_TYPE,
  MESSAGE_FOLDER,
} from 'constants/message-types';
import { ANIMATION_TIMEOUT_INOUT } from 'constants/animation.js';

import './styles.css';

const InboxItem = props => {
  const {
    user,
    item,
    actions: { onRead: handleOnRead },
    footerActions,
  } = props;

  const {
    Direction,
    Type,
    FromType,
    MessageFolderID,
    MessageFolderName,
    ToRead,
    ResumeRequestToken,
    ConnectionRequestToken,
    HasHtml,
  } = item;

  const actions = useMemo(() => {
    let actionsType;
    if (Type === MESSAGE_TYPE.TYPE_RESUME_REQUEST && Direction === 'Received') {
      actionsType = ResumeRequestToken ? 'Resume' : null;
    } else if (Type === MESSAGE_TYPE.TYPE_CONNECT && Direction === 'Received') {
      actionsType = ConnectionRequestToken ? 'Connect' : null;
    } else if (
      FromType &&
      FromType === MESSAGE_FROM_TYPE.FROM_TYPE_SYSTEM &&
      Number(MessageFolderID) !== MESSAGE_FOLDER.TRASH
    ) {
      actionsType = 'Sent';
    } else {
      actionsType = footerActions[MessageFolderName] ? MessageFolderName : null;
    }

    if (actionsType === 'Inbox' && item.FromAllowedReplyAction === 'No') {
      return footerActions[actionsType].map(item =>
        item.caption === 'Reply' ? { ...item, disabled: true } : item
      );
    }

    return actionsType ? footerActions[actionsType] : null;
  }, [footerActions, item]);

  const onRead = () => {
    if (Number(ToRead) === 0 && handleOnRead) {
      handleOnRead(item);
    }
  };

  const content = useMemo(() => {
    const hasHTML = HasHtml === 'Yes';
    return Direction === 'Sent' ? (
      <InboxItemTypeSent user={user} message={item} hasHTML={hasHTML} />
    ) : (
      <InboxItemTypeReceived
        user={user}
        message={item}
        hasHTML={hasHTML}
        actions={{ onRead }}
      />
    );
  }, [item]);

  return (
    <Spring
      from={{ opacity: 0 }}
      to={{ opacity: 1 }}
      config={{ duration: ANIMATION_TIMEOUT_INOUT }}
    >
      {props => (
        <div style={props}>
          <PanelContainer styles={{ padding: 0 }}>
            <article className="inbox-item">
              {content}
              {actions && (
                <div className="inbox-item__footer">
                  <ItemFooterActions actions={actions} item={item} />
                </div>
              )}
            </article>
          </PanelContainer>
        </div>
      )}
    </Spring>
  );
};

InboxItem.propTypes = {
  user: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  actions: PropTypes.shape({ onRead: PropTypes.func }).isRequired,
  footerActions: PropTypes.object.isRequired,
};

export default InboxItem;
